/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Onl_How_TitleInputs */

const en_vc_onl_how_title = /** @type {(inputs: Vc_Onl_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How VectorCraft online works`)
};

const zh_vc_onl_how_title = /** @type {(inputs: Vc_Onl_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft 在线版是怎么工作的`)
};

/**
* | output |
* | --- |
* | "How VectorCraft online works" |
*
* @param {Vc_Onl_How_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_onl_how_title = /** @type {((inputs?: Vc_Onl_How_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Onl_How_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_onl_how_title(inputs)
	return zh_vc_onl_how_title(inputs)
});
export { vc_onl_how_title as "vc.onl.how.title" }